import LogProvider from '../classes/log-provider'
import { isBrowser } from '../utils/environment'

const IS_BROWSER = isBrowser()

const parseTag = (tag) => (tag.serialize ? tag.serialize() : tag)
export default class GA4Provider extends LogProvider {
  static get is() {
    return 'GA4Provider'
  }

  constructor(config) {
    super(config)
  }

  // https://support.google.com/tagmanager/answer/7582054?hl=en
  // This supports both gtag or GTM logging methods. The preferred is GTM
  log(tag) {
    if (!IS_BROWSER) return

    if (GA4Provider.isGA4Format(tag)) {
      try {
        const data = GA4Provider.serialize(tag)
        if (typeof window.gtag === 'function') {
          GA4Provider.gtag('event', data.event, data.attributes)
        } else {
          GA4Provider.dataLayer.push(Object.assign({ event: data.event }, data.attributes))
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  static isGA4Format(tag) {
    const data = GA4Provider.serialize(tag)
    if (data.event && data.attributes) {
      return true
    } else {
      console.error('Please ensure your data object has the properties event and attributes')
      return false
    }
  }

  static get gtag() {
    return IS_BROWSER ? window.gtag : null
  }

  static get dataLayer() {
    let dataLayer = null
    if (IS_BROWSER) {
      if (!window.dataLayer) {
        dataLayer = window.dataLayer = []
      } else {
        dataLayer = window.dataLayer
      }
    }
    return dataLayer
  }

  static serialize(tag) {
    const data = parseTag(tag)
    data.attributes = tag?.data?.attributes
    return data
  }
}
